<template>
  <div class="header-new" v-if="isShowHeader">
    <!-- 状态栏占位高度 -->
    <div class="status" v-statusBarHeight="'height'"></div>
    <div class="header">
      <img class="icon" src="./images/left-arrow.png" @click="goBack" />
      <div class="content">
        <div class="text lc-1">{{ name }}</div>
      </div>
      <div class="right">
        <img class="icon" src="./images/more.png" alt="" @click="isShowMenu = !isShowMenu" />
      </div>
      <v-overlay :visible="isShowMenu" @click="isShowMenu = false"></v-overlay>
      <div :class="['mod-nav', isShowMenu ? 'show' : '']" v-statusBarHeight="'margin-top'">
        <a class="item home" :href="`${linkBase}/index.html`">首页</a>
        <div class="item buy" @click="toNav">选购商品</div>
        <div class="item center" @click="toMy">个人中心</div>
        <div class="item concat" @click="toConnect">在线客服</div>
      </div>
    </div>
  </div>
</template>
<script>
import clientEnv from '@/utils/clientEnv'
import { goBack, getQueryString } from 'utils/common'
import app from 'utils/app'
import shop from 'utils/shop'
import create from '../create'
import config from 'config'
export default create({
  name: 'header-new',
  props: {
    name: '',
    show: true
  },
  data() {
    return {
      isShowMenu: false,
      canShowAddress: false
    }
  },
  computed: {
    isShowHeader() {
      return !shop.hidenShopHeader()
    }
  },
  methods: {
    goBack() {
      goBack()
    },
    toNav() {
      if (clientEnv.isVivoApp) {
        app.openAppByDeepLink({
          deepLink: 'space://vivo.com/main?targetPackage=com.vivo.space&id=1&nativeType=31'
        })
      } else {
        location.href = `${this.linkBase}/product/phone`
      }
    },
    toMy() {
      if (clientEnv.isVivoApp) {
        app.openAppByDeepLink({
          deepLink: 'space://vivo.com/main?targetPackage=com.vivo.space&id=4&nativeType=31'
        })
      } else {
        location.href = `${this.linkBase}/my`
      }
    },
    toConnect() {
      window.location.href = config.path.shopKefu + '&source=orderpageh5'
    }
  }
})
</script>

<style lang="scss" scope>
.header-new {
  width: 100%;
  z-index: 10;
  background: #ffff;
  border-bottom: 1px solid #f2f2f2;
  top: 0;
  position: sticky;
  &.deposit {
    background: linear-gradient(180deg, #6637ff 3.72%, #957ff9 95.31%);
    border-bottom: none;
    .deposit-bg {
      position: absolute;
      width: 376px;
      height: 308px;
      top: 0px;
      left: 51px;
    }
    .header {
      .icon {
        filter: none;
      }
      .text {
        color: #ffff;
        &::after {
          background: rgba(240, 240, 240, 0.15);
        }
      }
    }
  }
  .header {
    height: 252px;
    padding: 0 72px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .icon {
      width: 72px;
      height: 72px;
      filter: invert(100%);
      flex-shrink: 0;
    }
    .content {
      padding: 0 20px;
    }
    .text {
      font-size: 45px;
      line-height: 53px;
      @include os-font-weight(45, 60);
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: #f0f0f0;
        height: 21px;
        width: 100%;
        z-index: -1;
      }
    }
    .right {
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
    }
  }
  .mod-nav {
    position: fixed;
    right: 48px;
    top: 160px;
    z-index: 890;
    width: 378px;
    padding: 20px 0;
    opacity: 0;
    background-color: #ffffff;
    box-shadow: 0px 30px 60px 0px rgba(0, 0, 0, 0.08);
    border-radius: 36px;
    border: solid 2px #e5e5e5;

    pointer-events: none;
    transition: opacity 0.1s ease-out;

    &.show {
      opacity: 1;
      pointer-events: auto;
    }

    .item {
      display: flex;
      align-items: center;
      width: 100%;
      height: 120px;
      font-size: 42px;
      line-height: 120px;
      color: #252525;

      &:last-child {
        margin: 0;
      }

      &.selected {
        color: #333;
      }
      &::before {
        content: '';
        display: inline-block;
        width: 54px;
        height: 54px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin: 0 25px 0 48px;
      }
      &.home {
        &::before {
          background-image: url('../header/img/home.png');
        }
      }
      &.center {
        &::before {
          background-image: url('../header/img/center.png');
        }
      }
      &.buy {
        &::before {
          background-image: url('../header/img/buy.png');
        }
      }
      &.concat {
        &::before {
          background-image: url('../header/img/concat.png');
          filter: brightness(0.5);
        }
      }
    }
  }
}
</style>
